import type { Column } from 'react-table'

import Button, { ButtonVariants } from '~/components/atoms/Button/Button'
import Container from '~/components/atoms/Container/Container'
import Link from '~/components/atoms/Link/Link'
import Loader from '~/components/atoms/Loader/Loader'
import Table from '~/components/atoms/Table/Table'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import { useLatestJobs } from '~/services/query'

import styles from './JobListingTable.module.css'

export interface JobListingTableProps {
  moduleId?: string
  testID?: string
}
export type JobListing = {
  title: string
  department: string
  location: string
  contractType: string
  currentSlug: string
  link: string
}

export default function JobListingTable({
  testID,
  moduleId,
}: JobListingTableProps) {
  const columns: Column<JobListing>[] = [
    {
      Header: (
        <Text uppercase size={TextSizes.bodySml}>
          Job Title
        </Text>
      ),

      accessor: 'title',
      minWidth: 300,
      Cell: data => (
        <Text size={TextSizes.bodySml}>
          <Link href={`/jobs/${data.row.original.currentSlug}`}>
            {data.value}
          </Link>
        </Text>
      ),
    },
    {
      Header: (
        <Text uppercase size={TextSizes.bodySml}>
          Department
        </Text>
      ),
      accessor: 'department',
      minWidth: 200,
      Cell: data => <Text size={TextSizes.bodySml}>{data.value}</Text>,
    },
    {
      Header: (
        <Text uppercase size={TextSizes.bodySml}>
          Location
        </Text>
      ),
      accessor: 'location',
      minWidth: 200,
      Cell: data => <Text size={TextSizes.bodySml}>{data.value}</Text>,
    },
    {
      Header: (
        <Text uppercase size={TextSizes.bodySml}>
          FT / PT
        </Text>
      ),
      accessor: 'contractType',
      minWidth: 100,
      Cell: data => <Text size={TextSizes.bodySml}>{data.value}</Text>,
    },
    {
      id: 'actions',
      accessor: 'link',
      Cell: data => (
        <Button
          className={styles.actionButton}
          link={data.value}
          iconLeft
          inline
          variant={ButtonVariants.secondaryDark}
        >
          View
        </Button>
      ),
      minWidth: 50,
      maxWidth: 100,
    },
  ]

  const { data = [], isLoading } = useLatestJobs()

  data.map(job => {
    job.link = `/jobs/${job.currentSlug}`
    return job
  })

  return (
    <div className={styles.base} data-testid={testID} id={moduleId}>
      <Container>
        <Text uppercase size={TextSizes.primaryTitleMed}>
          Current Vacancies
        </Text>

        {isLoading ? (
          <Loader />
        ) : (
          <>
            <Table<JobListing>
              name={'jobListingTable'}
              columns={columns}
              data={data}
            />
          </>
        )}
      </Container>
    </div>
  )
}
